import { inject, Provider } from '@angular/core';
import { FILE_PREVIEW_PROVIDER, IFilePreviewProvider } from '@sia/file-system';
import { SiaAIPromptApi } from '../apis/ai-prompt.api';

/**
 * Implementazione AI-specifica del provider di preview.
 * Usa SiaAIPromptApi per recuperare le anteprime dai controller AI.
 */
export class AiFilePreviewProvider implements IFilePreviewProvider {
  #api = inject(SiaAIPromptApi);

  retrievePreview(fileType: string, fileId: string): Promise<any> {
    // Il backend AI usa 'image' per tutte le immagini native (jpg, png, ecc.)
    return this.#api.retrieveOriginInformation(fileType, fileId);
  }

  retrieveTextContent(fileId: string): Promise<{ textContent: string }> {
    return this.#api.retrieveFileTextContent(fileId);
  }

  downloadFile(fileId: string): Promise<Blob> {
    return this.#api.downloadDocument(fileId);
  }
}

/**
 * Provider da usare nei componenti AI per fornire il FILE_PREVIEW_PROVIDER.
 * Esempio: providers: [AI_FILE_PREVIEW_PROVIDER]
 */
export const AI_FILE_PREVIEW_PROVIDER: Provider = {
  provide: FILE_PREVIEW_PROVIDER,
  useClass: AiFilePreviewProvider,
};
